import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["report", "text", "icon", "location"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { COMMERCE_PAYMENT_TYPE_ID, INVOICE_TYPE_ID, SUBSCRIPTION_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { Button } from 'foundations-components/transitional/components/Button';
import { useContext } from 'react';
import { useObjectTypeForZeroState } from '../hooks/useObjectTypeForZeroState';
import { createTracker } from 'usage-tracker';
import PaymentsEmbedPointContext from 'payments-embed-points-lib/context/PaymentsEmbedPointContext';
import PaymentsEmbedPointContextProvider from 'payments-embed-points-lib/context/PaymentsEmbedPointContextProvider';
import { Screen, Subscreen } from 'payments-embed-points-lib/types/screen';
import { CommerceToolNames } from 'payments-embed-points-lib/hooks/toolStatus/useCommerceToolStatus';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BUTTON_CONFIG = {
  [COMMERCE_PAYMENT_TYPE_ID]: {
    buttonLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-enablement.zeroState.alerts.payment.buttonLabel"
    }),
    tool: CommerceToolNames.paymentLinks
  },
  [INVOICE_TYPE_ID]: {
    buttonLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-enablement.zeroState.alerts.invoice.buttonLabel"
    }),
    tool: CommerceToolNames.invoices
  },
  [SUBSCRIPTION_TYPE_ID]: {
    buttonLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-enablement.zeroState.alerts.subscription.buttonLabel"
    }),
    tool: CommerceToolNames.subscriptions
  },
  setUpPayments: {
    buttonLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-enablement.zeroState.alerts.setUpPayments.buttonLabel"
    }),
    tool: 'setUpPayments'
  }
};
const getSubscreenForTool = tool => {
  switch (tool) {
    case 'paymentLinks':
      return Subscreen.REPORTS_PAYMENT_LINKS;
    case 'invoices':
      return Subscreen.REPORTS_INVOICES;
    case 'subscriptions':
      return Subscreen.REPORTS_SUBSCRIPTIONS;
    case 'setUpPayments':
      return Subscreen.SET_UP_PAYMENTS_REPORTING;
    default:
      return undefined;
  }
};
const CreateCommerceToolButtonForReport = _ref => {
  let {
      report,
      text,
      icon,
      location
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    getPaymentsInterstitialModalOpenHandler
  } = useContext(PaymentsEmbedPointContext);
  const openModal = getPaymentsInterstitialModalOpenHandler();
  const commerceZeroStateObjectTypeId = useObjectTypeForZeroState(report);
  const templateKey = report.get('templateKey');
  const {
    buttonLabel,
    tool
  } = BUTTON_CONFIG[commerceZeroStateObjectTypeId !== null && commerceZeroStateObjectTypeId !== void 0 ? commerceZeroStateObjectTypeId : ''];
  const handleButtonClick = () => {
    openModal();
  };
  const usageTracker = createTracker({
    standalone: true
  });
  return /*#__PURE__*/_jsxs(Button, Object.assign({
    use: "tertiary",
    size: "extra-small",
    onClick: () => {
      usageTracker.track('Reporting', 'Report Interaction', {
        action: 'createToolButtonClick',
        templateKey,
        tool,
        source: location
      });
      handleButtonClick();
    },
    paddingInline: "500",
    paddingBlock: "200"
  }, buttonProps, {
    children: [icon, text || buttonLabel]
  }));
};
export const CreateCommerceToolButtonForReportWithPaymentsEmbedPointContextProvider = props => {
  const {
    report
  } = props;
  const commerceZeroStateObjectTypeId = useObjectTypeForZeroState(report);
  const {
    tool
  } = BUTTON_CONFIG[commerceZeroStateObjectTypeId !== null && commerceZeroStateObjectTypeId !== void 0 ? commerceZeroStateObjectTypeId : ''];
  return /*#__PURE__*/_jsx(PaymentsEmbedPointContextProvider, {
    screen: Screen.REPORTS,
    subscreen: getSubscreenForTool(tool),
    children: /*#__PURE__*/_jsx(CreateCommerceToolButtonForReport, Object.assign({}, props))
  });
};